module.exports = __webpack_public_path__ + "static/media/ferry.71ffecd1.jpg";